import { merge, get, set } from 'lodash';
import { ADMIN } from '../../../actionTypes';
let initState = {
	// cityList: []
	brands: [],
	leaders: [],
	presses: [],
	dataGot: false,
	edited: false
};
function removeDefaultBrand(state) {
	state.brands.forEach(brand => {
		if (brand.isMainBrand === 1) {
			brand.isMainBrand = 0;
			brand.changeType = 1;
		}
	});
}
export function AdminPromotionReducers(state = initState, action) {
	console.log('promotion action', action);
	switch (action.type) {
		case ADMIN.PROMOTION_EDITED: {
			return {
				...state,
				edited: true
			};
		}
		case ADMIN.SET_PROMOTION: {
			let brands = action.data.organizationBrandList;
			let leaders = action.data.companyMemberList;
			let presses = action.data.companyMediaReportList;
			return Object.assign({}, state, {
				brands,
				leaders,
				presses,
				dataGot: true
			});
		}

		case ADMIN.ADD_PROMOTION_LEADER: {
			let leaders = [...state.leaders, action.leader];
			return merge(state, {
				leaders
			});
		}
		case ADMIN.ADD_PROMOTION_PRESS: {
			let presses = [...state.presses, action.press];
			return merge(state, {
				presses
			});
		}
		case ADMIN.ADD_PROMOTION_BRAND: {
			if (action.brand.isMainBrand === 1) {
				removeDefaultBrand(state);
			}
			let brands = [...state.brands, action.brand];
			return merge(state, {
				brands
			});
		}
		case ADMIN.EDIT_PROMOTION_BRAND: {
			if (action.brand.isMainBrand === 1) {
				removeDefaultBrand(state);
			}
			state.brands[action.index] = action.brand;
			//console.log(action.index, 'action.index', action.brand);
			return state;
		}
		case ADMIN.EDIT_PROMOTION_LEADER: {
			state.leaders[action.index] = action.leader;
			console.log(action.index, 'action.index', action.leader);
			return state;
		}
		case ADMIN.EDIT_PROMOTION_PRESS: {
			state.presses[action.index] = action.press;
			console.log(action.index, 'action.index', action.press);
			return state;
		}
		case ADMIN.DELETE_PROMOTION_BRAND: {
			state.brands[action.index] = action.brand;
			return state;
		}
		case ADMIN.DELETE_PROMOTION_LEADER: {
			state.leaders[action.index] = action.leader;
			return state;
		}
		case ADMIN.DELETE_PROMOTION_PRESS: {
			state.presses[action.index] = action.press;
			return state;
		}
		default:
			return state;
	}
}
